module.exports = __webpack_public_path__ + "static/media/carousel2.da5947a8.png";